import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokhatushyamtour() {


const cardData = {
keyword: "Pune to Khatu Shyam Tour Package",
headingDescription: "Citysky Cabs offers convenient and comfortable Pune to Khatu Shyam Tour Package services for devotees planning a spiritual journey from Pune to Khatu Shyam Ji Temple in Rajasthan. The service is suitable for one-way travel, round trips, darshan visits, family pilgrimages, and customized Rajasthan temple tours. Travelers can choose from comfortable AC cabs including sedans, 7-seater vehicles, Innova Crysta and other spacious options according to their group size. With planned pickup from Pune, flexible travel schedules, experienced drivers, and support for long-distance road journeys, the Pune to Khatu Shyam route can be arranged with practical travel options for families, senior citizens, and groups visiting Khatu Shyam along with nearby pilgrimage destinations such as Salasar Balaji, Jaipur and Pushkar.",
topPlaces: [
{
title: "Khatu Shyam Ji Temple",
description: "Khatu Shyam Ji Temple is the primary pilgrimage destination on this route and attracts devotees throughout the year. A dedicated cab service makes it easier to reach Khatu Shyam from Pune with a comfortable long-distance journey, flexible stopping points and convenient arrangements for darshan."
},
{
title: "Salasar Balaji Temple",
description: "Salasar Balaji is an important Hanuman pilgrimage destination in Rajasthan and is often included with Khatu Shyam Ji visits. Travelers can plan a combined spiritual circuit from Pune covering both temples with suitable cab arrangements, allowing families and groups to manage their pilgrimage itinerary comfortably."
},
{
title: "Jaipur",
description: "Jaipur provides an important stop for travelers combining their Khatu Shyam pilgrimage with Rajasthan sightseeing. The Pink City offers historic forts, palaces, markets and cultural attractions, making it suitable for a customized Pune to Khatu Shyam tour that includes additional destinations."
},
{
title: "Sikar",
description: "Sikar is located within the wider Shekhawati region and can be included when planning a Rajasthan pilgrimage around Khatu Shyam. A private cab allows travelers to maintain their own schedule while visiting religious places and exploring the traditional architecture and heritage areas of the region."
},
{
title: "Churu",
description: "Churu is known for its historic havelis, painted buildings and distinctive Shekhawati heritage. Travelers extending their Khatu Shyam journey can include Churu as part of a customized Rajasthan circuit, with private cab travel offering flexibility for families and small groups."
},
{
title: "Pushkar",
description: "Pushkar is a well-known pilgrimage destination featuring the sacred Pushkar Lake and Brahma Temple. It can be added to a longer Rajasthan spiritual tour from Pune, allowing travelers to combine Khatu Shyam darshan with another important religious destination in a planned private-cab itinerary."
},
{
title: "Ajmer",
description: "Ajmer is an important religious and cultural destination near Pushkar and can be incorporated into a multi-stop Rajasthan journey. Travelers can use a private cab to coordinate Khatu Shyam, Ajmer and Pushkar visits while keeping the route comfortable for families and senior passengers."
},
{
title: "Salasar",
description: "Salasar is particularly relevant for devotees planning a combined Khatu Shyam and Salasar Balaji pilgrimage. A dedicated cab can make it easier to coordinate temple visits, luggage, waiting time and return travel without depending on fixed public transport schedules."
},
{
title: "Neem Ka Thana",
description: "Neem Ka Thana is a practical regional stop in Rajasthan for travelers approaching the Khatu Shyam and Sikar areas. It can be included in customized travel plans where passengers need intermediate stops, accommodation access or additional local travel during their pilgrimage."
},
{
title: "Ringas",
description: "Ringas is an important access point for visitors traveling toward Khatu Shyam Ji Temple and is frequently associated with pilgrimage travel to the temple. Private cab service can connect Pune travelers directly with Ringas and Khatu Shyam while allowing convenient pickup, drop and return arrangements."
}
],
services: [
{
name: "pune to khatu shyam yatra package",
description: "The Pune to Khatu Shyam Yatra Package is designed for devotees looking for organized private-cab travel to Khatu Shyam Ji Temple. Citysky Cabs can accommodate different group sizes and travel requirements with comfortable vehicles, planned routes, suitable breaks and flexible one-way or round-trip arrangements."
},
{
name: "Pune to Khatu Shyam Cab Service",
description: "Pune to Khatu Shyam Cab Service provides private road transportation from Pune to the Khatu Shyam pilgrimage destination in Rajasthan. The journey can be arranged in an AC sedan, SUV, 7-seater or Innova Crysta according to passenger requirements, with convenient pickup and destination drop options."
},
{
name: "Pune to Khatu Shyam Taxi Service",
description: "Pune to Khatu Shyam Taxi Service is suitable for devotees, families and groups requiring a dedicated vehicle for this long-distance Rajasthan journey. Citysky Cabs focuses on comfortable seating, planned travel schedules, experienced drivers and flexible stops throughout the route."
},
{
name: "Pune to Khatu Shyam Cab Booking",
description: "Pune to Khatu Shyam Cab Booking allows travelers to reserve a private vehicle according to their planned pilgrimage dates and group size. Customers can discuss pickup location, vehicle category, one-way or return requirements and additional temple destinations before finalizing their travel arrangement."
},
{
name: "Pune to Khatu Shyam One Way Cab",
description: "Pune to Khatu Shyam One Way Cab is a practical option for travelers who need a dedicated vehicle from Pune to Rajasthan without booking the same cab for the return journey. The service can be arranged for individuals, couples, families and groups requiring direct long-distance transportation."
},
{
name: "Pune to Khatu Shyam Round Trip Cab",
description: "Pune to Khatu Shyam Round Trip Cab is suitable for devotees planning both onward and return travel between Pune and Khatu Shyam. A round-trip arrangement can provide greater flexibility for temple darshan, overnight stays and additional pilgrimage stops such as Salasar Balaji, Ajmer or Pushkar."
},
{
name: "Pune to Khatu Shyam Taxi Fare",
description: "Pune to Khatu Shyam Taxi Fare depends on factors such as vehicle type, total travel distance, one-way or round-trip requirement, number of passengers, route planning and additional sightseeing or waiting time. Citysky Cabs can help travelers understand the applicable fare structure before confirming the journey."
},
{
name: "Pune to Khatu Shyam Cab Charges",
description: "Pune to Khatu Shyam Cab Charges vary according to the selected vehicle and travel plan. Sedan, SUV, 7-seater and Innova Crysta options can be considered based on passenger count, luggage and comfort requirements, while additional stops or customized Rajasthan itineraries may affect the overall charges."
},
{
name: "Pune to Khatu Shyam Car Rental",
description: "Pune to Khatu Shyam Car Rental offers a private vehicle for devotees who prefer flexible long-distance travel instead of shared transportation. The rental arrangement can support direct temple travel as well as customized routes covering Khatu Shyam, Salasar Balaji, Jaipur, Ajmer and other Rajasthan destinations."
},
{
name: "Pune to Khatu Shyam Outstation Cab",
description: "Pune to Khatu Shyam Outstation Cab is designed for long-distance travel from Pune to Rajasthan with dedicated vehicle and driver support. Travelers can select a suitable AC cab for their group and plan convenient breaks, overnight stays and additional pilgrimage destinations along the route."
},
{
name: "Pune to Khatu Shyam Innova Crysta Cab",
description: "Pune to Khatu Shyam Innova Crysta Cab provides a spacious and comfortable option for families and groups traveling on the long Pune-Rajasthan route. The vehicle offers generous seating and luggage space, making it suitable for extended road journeys and multi-day pilgrimage plans."
},
{
name: "Pune to Khatu Shyam 7 Seater Cab",
description: "Pune to Khatu Shyam 7 Seater Cab is suitable for medium-sized families or groups who want to travel together in one spacious vehicle. It provides a convenient solution for passengers carrying luggage and planning temple visits, overnight stays and additional Rajasthan sightseeing."
},
{
name: "Pune to Khatu Shyam Family Cab Service",
description: "Pune to Khatu Shyam Family Cab Service is planned for families seeking private and comfortable transportation for a religious journey. Vehicle selection can be matched with family size, luggage and senior passenger requirements, while flexible stops can make the lengthy road trip more convenient."
},
{
name: "Pune to Khatu Shyam Darshan Cab",
description: "Pune to Khatu Shyam Darshan Cab is focused on convenient private travel for devotees visiting Khatu Shyam Ji Temple. Travelers can plan direct transportation to the temple area and coordinate the journey with suitable waiting, return travel or additional pilgrimage destinations according to their schedule."
},
{
name: "Pune to Khatu Shyam Temple Cab Booking",
description: "Pune to Khatu Shyam Temple Cab Booking helps devotees arrange direct private transportation from Pune to the temple destination in Rajasthan. The service can be customized around pilgrimage dates, passenger count, vehicle preference and return requirements for a smoother temple visit."
},
{
name: "Pune to Khatu Shyam Taxi Price Per Km",
description: "Pune to Khatu Shyam Taxi Price Per Km can vary according to the vehicle category, route conditions, trip type and applicable travel terms. Travelers can compare suitable sedan, SUV, 7-seater and Innova Crysta options while considering the total distance and any additional stops included in the itinerary."
},
{
name: "Cheap Cab Pune to Khatu Shyam",
description: "Cheap Cab Pune to Khatu Shyam is intended for travelers looking for a practical and budget-conscious private travel option without choosing shared transportation. Vehicle selection based on group size and advance trip planning can help manage the overall cost of this long-distance pilgrimage journey."
},
{
name: "Best Cab Service Pune to Khatu Shyam",
description: "Best Cab Service Pune to Khatu Shyam offers a range of private travel options for devotees planning the long road journey to Rajasthan. Citysky Cabs supports different passenger requirements with comfortable vehicles, experienced drivers, flexible schedules and arrangements for one-way, round-trip and multi-destination trips."
},
{
name: "Pune to Khatu Shyam AC Cab Service",
description: "Pune to Khatu Shyam AC Cab Service provides air-conditioned private transportation for travelers undertaking the lengthy journey from Pune to Rajasthan. AC sedan, SUV and larger vehicle options can be selected according to group size, luggage requirements and desired travel comfort."
},
{
name: "Pune to Khatu Shyam Luxury Cab",
description: "Pune to Khatu Shyam Luxury Cab is suitable for travelers who prefer an enhanced private travel experience for their pilgrimage journey. Spacious premium vehicle options can be arranged for families, corporate groups or passengers seeking additional comfort during the long-distance Pune to Rajasthan road trip."
}
],
tableData: [
["pune to khatu shyam yatra package"],
["Pune to Khatu Shyam Cab Service"],
["Pune to Khatu Shyam Taxi Service"],
["Pune to Khatu Shyam Cab Booking"],
["Pune to Khatu Shyam One Way Cab"],
["Pune to Khatu Shyam Round Trip Cab"],
["Pune to Khatu Shyam Taxi Fare"],
["Pune to Khatu Shyam Cab Charges"],
["Pune to Khatu Shyam Car Rental"],
["Pune to Khatu Shyam Outstation Cab"],
["Pune to Khatu Shyam Innova Crysta Cab"],
["Pune to Khatu Shyam 7 Seater Cab"],
["Pune to Khatu Shyam Family Cab Service"],
["Pune to Khatu Shyam Darshan Cab"],
["Pune to Khatu Shyam Temple Cab Booking"],
["Pune to Khatu Shyam Taxi Price Per Km"],
["Cheap Cab Pune to Khatu Shyam"],
["Best Cab Service Pune to Khatu Shyam"],
["Pune to Khatu Shyam AC Cab Service"],
["Pune to Khatu Shyam Luxury Cab"]
],
whychoose: [
{
WhyChooseheading: "Dedicated Pilgrimage Travel Planning",
WhyChoosedescription: "Khatu Shyam journeys often involve temple timings, long road travel and additional religious stops. Citysky Cabs can help organize the cab plan around the travel schedule, group size, preferred vehicle and destinations included in the pilgrimage."
},
{
WhyChooseheading: "Comfortable Vehicles for Long Routes",
WhyChoosedescription: "A Pune to Rajasthan road journey requires suitable seating and luggage space, especially when traveling with family or senior citizens. Sedan, 7-seater, SUV and Innova Crysta options provide different levels of space for different passenger requirements."
},
{
WhyChooseheading: "One-Way and Round-Trip Flexibility",
WhyChoosedescription: "Travel plans can differ from one devotee to another, so the service supports both one-way and round-trip requirements. Passengers can select the arrangement that fits their onward travel plans, return schedule and duration of stay in Rajasthan."
},
{
WhyChooseheading: "Suitable for Families and Groups",
WhyChoosedescription: "Families traveling for Khatu Shyam darshan can choose a private vehicle rather than coordinating multiple seats on public transport. Larger vehicles also make it easier to accommodate luggage and keep the entire group together throughout the journey."
},
{
WhyChooseheading: "Multi-Destination Rajasthan Trips",
WhyChoosedescription: "The journey can be extended beyond Khatu Shyam to destinations such as Salasar Balaji, Jaipur, Ajmer and Pushkar. This makes private cab travel useful for devotees who want to combine several religious or cultural destinations in one itinerary."
},
{
WhyChooseheading: "Planned Pickup from Pune",
WhyChoosedescription: "Pickup arrangements can be coordinated according to the traveler's Pune location and departure schedule. Advance planning helps the group begin the long-distance journey smoothly while allowing vehicle and passenger requirements to be discussed before departure."
},
{
WhyChooseheading: "Transparent Travel Coordination",
WhyChoosedescription: "Before the trip, passengers can discuss vehicle category, travel type, route requirements, additional stops and applicable charges. Clear coordination helps travelers understand the planned journey and select an arrangement suitable for their pilgrimage."
},
{
WhyChooseheading: "Private Cab Convenience",
WhyChoosedescription: "Private cab travel gives devotees greater control over departure times, rest breaks, luggage and sightseeing stops. For a long pilgrimage route such as Pune to Khatu Shyam, this flexibility can make the overall road journey easier to coordinate for individuals, families and groups."
}
]
};











const faqData = [
{
question: "How can I plan a Pune to Khatu Shyam Tour Package with Citysky Cabs?",
answer: "Devotees planning a Khatu Shyam pilgrimage from Pune can share their preferred travel dates, passenger count, pickup location, number of days, and return requirements with Citysky Cabs. The transportation plan can be discussed around the temple visit, overnight stays, sightseeing stops, and the preferred route."
},
{
question: "Can I travel from Pune to Khatu Shyam Ji by private cab?",
answer: "A private cab can be considered for devotees who prefer travelling together from Pune to Khatu Shyam Ji. The journey can be planned according to the group's schedule, luggage requirements, overnight halts, meal breaks, and any additional religious destinations included in the pilgrimage."
},
{
question: "Is a Pune to Khatu Shyam tour suitable for families?",
answer: "Families can enquire about a dedicated cab arrangement for a Khatu Shyam pilgrimage, particularly when children, parents, or elderly relatives are travelling together. A private vehicle allows the group to coordinate rest breaks, luggage, temple visits, and the overall itinerary according to their requirements."
},
{
question: "Can I book a multi-day Pune to Khatu Shyam pilgrimage?",
answer: "Devotees planning a long-distance pilgrimage can discuss a multi-day transportation arrangement based on the preferred route and travel schedule. The itinerary can include overnight stays, temple visits, meal breaks, sightseeing locations, and additional pilgrimage destinations before returning to Pune."
},
{
question: "Can other religious places be included in the Khatu Shyam tour from Pune?",
answer: "Travellers who want to combine Khatu Shyam Ji with other religious destinations can mention the complete itinerary during the enquiry. Additional temples or pilgrimage locations can be discussed according to the available travel days, preferred route, overnight requirements, and group's schedule."
},
{
question: "Can senior citizens travel from Pune to Khatu Shyam Ji by cab?",
answer: "Families travelling with senior citizens can discuss a private cab itinerary with suitable rest breaks and a manageable travel schedule. Direct transportation can make long-distance group travel easier to coordinate, especially when the journey includes luggage, overnight halts, and multiple religious stops."
},
{
question: "Can I arrange a round-trip cab from Pune to Khatu Shyam?",
answer: "Travellers who require transportation from Pune to Khatu Shyam Ji and back can enquire about a round-trip arrangement. The expected duration, temple visit schedule, overnight stays, additional destinations, and preferred return date can be shared while planning the complete journey."
},
{
question: "Can a group of devotees hire a cab for the Pune to Khatu Shyam tour?",
answer: "Groups of devotees can enquire about private transportation when several passengers want to complete the pilgrimage together. Vehicle selection can be discussed according to the number of travellers, luggage volume, number of travel days, and the planned religious itinerary."
},
{
question: "Can I carry luggage during the Pune to Khatu Shyam pilgrimage?",
answer: "Passengers can carry normal personal and pilgrimage-related luggage during the journey. For longer tours involving several bags, it is useful to provide the approximate luggage quantity and passenger count in advance so Citysky Cabs can discuss a suitable vehicle for the trip."
},
{
question: "What details are required for a Pune to Khatu Shyam Tour Package?",
answer: "For an enquiry, provide the Pune pickup location, preferred travel dates, number of devotees, expected number of days, luggage details, and return requirement. Mention any additional temples, sightseeing stops, overnight stays, or special travel needs so the pilgrimage transportation can be planned accordingly."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Dinesh Agarwal",
feedback:
"We were planning a Khatu Shyam Ji pilgrimage from Pune with a group of relatives and wanted to travel together rather than use different vehicles. I shared our dates and itinerary with Citysky Cabs and arranged the cab for the journey. The private transportation made it easier to manage our luggage, rest breaks, and temple schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Kavita Sharma",
feedback:
"My parents and I planned a longer pilgrimage that included Khatu Shyam Ji, and we wanted the flexibility of travelling at our own pace. Citysky Cabs arranged the cab after we discussed the route and number of travel days. Having one vehicle throughout the trip was helpful, especially while travelling with elderly family members and luggage.",
rating: 5
}
];




























































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Khatu Shyam Tour Package",
  "image": "https://www.cityskycab.in/assets/images/pune-to-khatu-shyam-tour-package.webp",
  "description": "Pune to Khatu Shyam Tour Package from Citysky Cabs provides private pilgrimage transportation for families, devotees and groups planning Khatu Shyam Ji Darshan from Pune. The service covers Pune to Khatu Shyam Yatra Package, Pune to Khatu Shyam Cab Service, Pune to Khatu Shyam Taxi Service, Pune to Khatu Shyam Cab Booking, Pune to Khatu Shyam One Way Cab and Pune to Khatu Shyam Round Trip Cab requirements. Travellers can choose sedan, Ertiga or Innova Crysta vehicles according to passenger count, luggage and tour duration. Customized pilgrimage itineraries can include Khatu Shyam Ji Temple and additional Rajasthan religious or sightseeing destinations according to travel plans. Citysky Cabs supports flexible pickup locations across Pune and Pimpri Chinchwad for one-way journeys, round trips and multi-day Khatu Shyam Yatra packages.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-khatu-shyam-tour-package"
  }
};






    return (
        <div>


<Helmet>
  <title>
    Pune to Khatu Shyam Tour Package | Darshan Cab & Yatra | +91 8554819191
  </title>

  <meta
    name="description"
    content="Pune to Khatu Shyam Tour Package by Citysky Cabs for Khatu Shyam Ji Darshan. Book one-way, round-trip or multi-day yatra by Ertiga or Innova Crysta."
  />

  <meta
    name="keywords"
    content="Pune to Khatu Shyam Tour Package, Pune to Khatu Shyam yatra package, Pune to Khatu Shyam Cab Service, Pune to Khatu Shyam Taxi Service, Pune to Khatu Shyam Cab Booking, Pune to Khatu Shyam One Way Cab, Pune to Khatu Shyam Round Trip Cab, Pune to Khatu Shyam cab, Pune to Khatu Shyam taxi, Pune Khatu Shyam tour package, Pune Khatu Shyam yatra, Khatu Shyam tour package from Pune, Khatu Shyam yatra from Pune, Khatu Shyam Ji tour package from Pune, Khatu Shyam Ji yatra package from Pune, Pune to Khatu Shyam Darshan package, Pune to Khatu Shyam Ji Darshan cab, Pune to Khatu Shyam Ji taxi, cab from Pune to Khatu Shyam, taxi from Pune to Khatu Shyam, Pune to Khatu Shyam car rental, Pune to Khatu Shyam car booking, Pune to Khatu Shyam private cab, Pune to Khatu Shyam outstation cab, Pune to Khatu Shyam cab fare, Pune to Khatu Shyam taxi fare, Pune to Khatu Shyam cab price, Pune to Khatu Shyam cab charges, Pune to Khatu Shyam return cab, Pune to Khatu Shyam round trip taxi, Pune to Khatu Shyam one way taxi, Pune to Khatu Shyam sedan cab, Pune to Khatu Shyam Ertiga cab, Pune to Khatu Shyam Innova cab, Pune to Khatu Shyam Innova Crysta cab, Pune to Khatu Shyam AC cab, Pune to Khatu Shyam family cab, Pune to Khatu Shyam pilgrimage cab, Pune to Khatu Shyam temple tour, Pune to Khatu Shyam religious tour package, Pune to Rajasthan Khatu Shyam tour package, Pune Khatu Shyam Rajasthan cab package, Pune to Khatu Shyam multi day tour, Pune Airport to Khatu Shyam cab, Pimpri Chinchwad to Khatu Shyam cab, PCMC to Khatu Shyam taxi, Khatu Shyam to Pune cab, Khatu Shyam to Pune taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/39.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokhatushyamtour;